import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue';
import template from './index.vdt';
import { sizes } from '../../styles/utils';
import { Dropdown } from '../dropdown';
import { useConfigContext } from '../config';
var typeDefs = {
  value: {
    type: String,
    required: true
  },
  presets: Array,
  size: sizes,
  disabled: Boolean,
  container: [Function, String],
  show: Boolean,
  position: Dropdown.typeDefs.position
};
var defaults = function defaults() {
  return {
    presets: ['#D0021B', '#F5A623', '#F8E71C', '#8B572A', '#7ED321', '#417505', '#BD10E0', '#9013FE', '#4A90E2', '#50E3C2', '#B8E986', '#000000', '#4A4A4A', '#9B9B9B', '#FFFFFF'],
    size: 'default',
    position: {
      collision: 'fit'
    }
  };
};
export var Colorpicker = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Colorpicker, _Component);
  function Colorpicker() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  return Colorpicker;
}(Component);
Colorpicker.template = template;
Colorpicker.typeDefs = typeDefs;
Colorpicker.defaults = defaults;